import translate from "@insite/client-framework/Translate";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import React from "react";

export function generateSelectOptions (options: string[], includePlaceholder: boolean, placeholder?: string) {
    const selectOptions = options.map((option) => {
        return (
            <option key={uniqueId()} value={option}>
                {option}
            </option>
        );
    });

    if(includePlaceholder && placeholder && placeholder !== "") {
        selectOptions.unshift(<option key={uniqueId()} disabled selected hidden value="">
            {translate(placeholder)}
        </option>);
    }

    return selectOptions;
}